import React from 'react'

const Banner = (props) => (
    <section id="banner" className="major">
        <div className="inner">
            <header className="major">
                <h1>You have the idea, we'll help you build it</h1>
            </header>
            <div className="content">
                <p>Tap into our expertise in getting your software development up and running.<br />
                And release that dream product to the market.</p>
                {/*<ul className="actions">
                    <li><a href="#who" className="button scrolly">Learn more...</a></li>
                </ul>*/}
                <ul className="actions">
                    <li><a href="#contact" className="button next scrolly">Get in touch</a></li>
                </ul>
            </div>
        </div>
    </section>
)

export default Banner
